export default __webpack_public_path__ + "locales/fi/JavascriptSdk.json?hash=238b9fb9483c03117f8dc42009f05b79";